import { QueryString } from "@/app/shared/filter";

export class SearchUserQueryString extends QueryString {
    public override get isNoValue(): boolean {
        return this._value === '';
    }
    override _fieldModelName: string = "searchTerm";
    override _fieldName: string = "s";
    constructor(value: any = "", sort: number = 0) {
        super();
        this._value = value;
    }
}